import React, { Component } from "react";
import { ProjectService } from "../Services/ProjectService";
import { JobStatusTransactionService } from "../Services/JobStatusTransactionService";
import { JobActionService } from "../Services/JobActionService";
import { UserService } from "../Services/UserService";
import {toInt, getTimeInIST, format, format_display} from '../Utils';
import Paper from '@material-ui/core/Paper';
import SelectDropdown from '../components/SelectDropdown';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { RowCountOptions } from "../Config";
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
// import HelpIcon from '@material-ui/icons/Help';
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
// import ListItemText from '@material-ui/core/ListItemText';
// import IconButton from '@material-ui/core/IconButton';
// import DeleteIcon from '@material-ui/icons/Delete';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';

const styles = theme =>({
    fab: {
        margin: theme.spacing.unit,
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      paddingTop : theme.spacing.unit, 
      paddingLeft: theme.spacing.unit, 
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    tablecell: {
        fontSize: '40pt',
        padding: '5px'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    table: {
        minWidth: 700
    },
    list: {
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "30%",
        },
        right: "22px"
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    formControl: {
        margin: theme.spacing.unit,
        marginTop: theme.spacing.unit * 3,
        minWidth: 200,
        marginLeft: theme.spacing.unit * 2,
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing.unit * 4,
        },
    }
  });

class JobStatusTransaction extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        originalData: [],
        current_rows: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,
        filter: '',
        new_transaction: {id: undefined, project_id: "", job_action_id: "", user_id: "", qty: "", comments: ""},
        show: false,
        columns : [
            { id: 'project_name', numeric: false, disablePadding: true, label: 'Project', sortable: true },
            { id: 'contractor_name', numeric: false, disablePadding: true, label: 'Contractor' , sortable: true },
            { id: 'job_action_name', numeric: false, disablePadding: true, label: 'Job Action', sortable: true  },
            { id: 'qty', numeric: false, disablePadding: true, label: 'Quantity', sortable: true  },
            { id: 'comments', numeric: false, disablePadding: true, label: 'Comments', sortable: true  },
            { id: 'txn_date', numeric: false, disablePadding: true, label: 'Transaction Date' , sortable: true },
            { id: 'created_by', numeric: false, disablePadding: true, label: 'Created By', sortable: true  },
        ],
        order: 'asc',
        orderBy: 'name',
        message : '',
        master_job_actions: [],
        startDate: moment().subtract(7, "days"),
        endDate: moment(),
        project_names: [],
        project_names_master: [],
        selected_project: "-1",
        error_fields: {project_id : false, user_id: false, job_action_id: false, qty: false, comments: false}
      }

      this.handleSelect = this.handleSelect.bind(this);

      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.newTransaction = this.newTransaction.bind(this);
      this.createModifyTransaction = this.createModifyTransaction.bind(this);

      //Sort
      this.sortBy = this.sortBy.bind(this);
    }

    componentWillMount(){
        this.props.setTitle('Job Status Transactions');
        this.props.isLoading(true);
        this.fetchContractors();
        ProjectService.getProjectNames()
        .then((data) => {
            let project_names = data.projects.filter(p => p.status !== '-999').map((project) => (
                <MenuItem key={project.id} value={project.id}>{project.name}</MenuItem>
            ));   
            project_names.unshift(<MenuItem key={"-1"} value={"-1"}>All Projects</MenuItem>);
            this.setState({project_names_master: data.projects.filter(p => p.status !== '-999'), project_names: project_names});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchJobActions(project_id){
        JobActionService.getJobActions(project_id)
        .then((data) => {
            this.setState({master_job_actions: data.job_actions});
        })
        .catch((error) =>{
            console.log("Error while fetching Job Actions list");
        });
    }

    fetchContractors(){
        UserService.getContractorList()
        .then((data) => {
            this.setState({master_contractors: data.users});
        })
        .catch((error) =>{
            console.log("Error while fetching Contractors list");
        });
    }
 
    componentDidMount(){
        this.fetchData(0, this.state.numItemsPerPage);
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
    
        if (this.state.orderBy === property && this.state.order === 'desc') {
          order = 'asc';
        }
    
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchData(start, numberItems){
        this.props.isLoading(true);
        let rows = [];
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        let project_id = this.state.selected_project === "-1" ? null : this.state.selected_project;

        JobStatusTransactionService.getTotalCount(project_id, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format))
        .then((data) => {
            this.setState({
                totalItems: toInt(data.count), 
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
            });
            JobStatusTransactionService.getJobStatusTransactions(start, numberItems, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format), project_id, null, null, sort, direction)
            .then((data) => {
                this.setState({data: data.transactions, originalData: data.transactions});
                if(data.transactions){
                    data.transactions.forEach((txn) => {
                        rows.push(<TransactionDetails key={txn.id} txn={txn}/>);
                    });
                    this.setState({
                        current_rows: rows
                    });
                }
                
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
        })
        .catch(error => {
            console.log(error);
        });
    }

    handleChange = (e) => {
        if(e.target.name === 'project_id'){
            this.fetchJobActions(e.target.value);
        }
        e.preventDefault();
        let change = this.state.new_transaction;
        change[e.target.name] = e.target.value;

        let error_fields = this.state.error_fields;
        error_fields[e.target.name] = false;
        
        this.setState({
            new_transaction: change,
            error_fields: error_fields
        });
    }

    newTransaction(e, project){
        if(project) {
            //Add previous contract values to state and populate the form
            let rows = this.updateProjectItemRows(project.items);
            this.setState({new_transaction: {id: project.id, name: project.name, description: project.description, qty: project.qty, status: project.status, created_date: project.created_date, created_by: project.created_by, modified_date: project.modified_date, items:  project.items.slice(), job_actions: project.job_actions.slice()}, item_rows: rows});
        }
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_transaction: {id: undefined, project_id: "", job_action_id: "", user_id: "", qty: "", comments: ""},
            error_fields: {project_id : false, user_id: false, job_action_id: false, qty: false, comments: false}
        });
    }
    
    handleShow() {
        if(this.state.project_names_master.length === 1){

        }
        this.setState({ show: true });
        this.setState(prevState => ({
            show: true,
            new_transaction: {
                ...prevState.new_transaction,
                project_id: this.state.project_names_master.length === 1 ? this.state.project_names_master[0].id : ""
            }
        }), () => this.state.project_names_master.length === 1 ? this.fetchJobActions(this.state.project_names_master[0].id): undefined);
    }

    confirmSave = () => {
        let new_transaction = this.state.new_transaction;
        // this.props.isLoading(true);
        new_transaction.comments = new_transaction.comments && new_transaction.comments.length ?  new_transaction.comments: null;
        new_transaction.txn_date = moment.utc().format(format);
        let headers = {user_id : this.props.user.id };
        JobStatusTransactionService.createTransaction(headers, {transactions: [new_transaction]})
        .then((response) => {
            this.props.closeConfirmDialog();
            // this.props.isLoading(false);
            console.log(response);
            if(response.status === 412){
                this.props.showConfirmDialog("Quantity exceeds the project quantity. Please change the project configuration first if the quantity has changed.", "Warning", undefined);
                this.setState(prevState => ({
                    error_fields: {
                        ...prevState.error_fields,
                        qty: true
                    }
                }));

            } else {
                this.handleClose();
                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
            }
        })
        .catch(error => {
            this.props.showSnackBar(`Something went wrong. Please try again later.` , 'error');
            this.props.isLoading(false);
        });
    }

    createModifyTransaction(e){
        e.preventDefault();
        let new_transaction = this.state.new_transaction;
        let error_fields = this.state.error_fields;
        if(new_transaction.project_id && new_transaction.job_action_id && new_transaction.user_id && toInt(new_transaction.qty) > 0){
            this.setState({new_transaction : new_transaction}, () => this.props.showConfirmDialog("Create transaction", "Confirm", this.confirmSave));
            return;
        }
        if(!new_transaction.project_id) {
            error_fields.project_id = true;
        }
        if((toInt(new_transaction.qty)|| 0) <= 0) {
            error_fields.qty = true;
        } 
        if(!new_transaction.job_action_id){
            error_fields.job_action_id = true;
        } 
        if(!new_transaction.user_id){
            error_fields.user_id = true;
        }
        this.setState({error_fields: error_fields});
    }
    
    handleSelect(eventKey, e) {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage){
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    handleProjectSelection = (e) => {
        console.log(e.target.value);
        this.setState({selected_project: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeStartDate = (date) => {
        console.log(date);
        this.setState({
            startDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }
    
    render() {
        let message = this.state.message;
        const { classes } = this.props;
        return (
            <div className="Home">
                <FormControl variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                        this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-age-simple"
                    >
                        Project
                    </InputLabel>
                    <Select
                        value={this.state.selected_project}
                        onChange={this.handleProjectSelection}
                        input={
                        <OutlinedInput
                            labelWidth={50}
                            name="Project"
                            id="outlined-age-simple"
                        />
                        }
                    >
                        {this.state.project_names}
                    </Select>
                </FormControl>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                        margin="normal"
                        label="From"
                        value={this.state.startDate}
                        onChange={this.handleChangeStartDate}
                        format='DD MMM YYYY'
                        maxDate={this.state.endDate}
                        variant="outlined"
                        className={classes.formControl}
                        style={{float: "left", height: "100%", marginTop: "24px"}}
                    />
                    <DatePicker
                        margin="normal"
                        label="To"
                        value={this.state.endDate}
                        onChange={this.handleChangeEndDate}
                        maxDate={moment()}
                        format='DD MMM YYYY'
                        variant="outlined"
                        className={classes.formControl}
                        style={{float: "left", height: "100%", marginTop: "24px"}}
                    />
                </MuiPickersUtilsProvider>
                <div className="container">
                    <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    { !message &&
                        <Paper className={this.props.classes.root} style={{width: "100%", marginTop: "50px", paddingLeft: "5px", paddingRight: "5px"}}>
                            <Table className={classes.table}>
                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.sortBy}
                                    rows ={this.state.columns} />
                                    { !this.props.loading && 
                                        <TableBody>
                                            {this.state.current_rows}
                                        </TableBody>
                                    }
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={RowCountOptions}
                                component="div"
                                count={this.state.totalItems}
                                rowsPerPage={this.state.numItemsPerPage}
                                page={this.state.currentPageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                        </Paper>
                    }
                </div>
                <DialogMUI
                    disableBackdropClick
                    disableEscapeKeyDown
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">Create Transaction</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <SelectDropdown required error={this.state.error_fields.project_id} label="Project" hint="Select Project" name="project_id" options={this.state.project_names_master} value={this.state.new_transaction.project_id} onChange={this.handleChange} />
                                <SelectDropdown required error={this.state.error_fields.job_action_id} disabled={this.state.master_job_actions.length === 0} label="Job Action" hint="Select Job Action" name="job_action_id" options={this.state.master_job_actions} value={this.state.new_transaction.job_action_id} onChange={this.handleChange} />
                                <SelectDropdown required error={this.state.error_fields.user_id} disabled={this.state.master_job_actions.length === 0} label="Contractor" hint="Select Contractor" name="user_id" options={this.state.master_contractors} value={this.state.new_transaction.user_id} onChange={this.handleChange} />
                                <TextField
                                    id="qty"
                                    label="Quantity"
                                    placeholder="Quantity"
                                    name="qty"
                                    defaultValue={this.state.new_transaction.qty}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    error={this.state.error_fields.qty}
                                    helperText="Enter Quantity"
                                    type="number"
                                    InputProps={{
                                        inputProps: { min: 1 }
                                    }}
                                    />
                                <TextField
                                    id="comment"
                                    label="Comments"
                                    placeholder="Comments"
                                    name="comments"
                                    fullWidth
                                    error={this.state.error_fields.comments}
                                    defaultValue={this.state.new_transaction.comment}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    multiline
                                    rows="2"
                                    type="text"
                                    />
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Close
                            </Button>
                            <Button onClick={this.createModifyTransaction} color="primary" autoFocus>
                                Save
                            </Button>
                        </DialogActions>
                </DialogMUI>
                { this.state.project_names_master.length > 0 && 
                    <Fab onClick={this.newTransaction} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', top: '85%', left: '90%'}}>
                        <AddIcon />
                    </Fab>
                }
            </div>
        );
    }

}

class TransactionDetails extends Component {

    render(){
      const txn = this.props.txn;

        return (
            <TableRow key={txn.id}>
                <TableCell component="th" scope="row" align="center" padding='none'>
                    <Typography variant="subtitle2">{txn.project_name}</Typography>
                </TableCell>
                <TableCell align="center"  padding='none'><Typography variant="subtitle2">{txn.contractor_name}</Typography></TableCell>
                <TableCell align="center"  padding='none'><Typography variant="subtitle2">{txn.job_action_name}</Typography></TableCell>
                <TableCell align="center"  padding='none'><Typography variant="subtitle2">{txn.qty}</Typography></TableCell>
                <TableCell align="center"  padding='none'><Typography variant="body1" color="textSecondary">{txn.comments}</Typography></TableCell>
                <TableCell align="center"  padding='none'>{getTimeInIST(txn.txn_date).format(format_display)}</TableCell>
                <TableCell align="center"  padding='none'>{txn.created_by}</TableCell>
            </TableRow>
        );
    }
}

export default withStyles(styles)(JobStatusTransaction);